import { Point } from "ol/geom";
import { Stroke, Style } from "ol/style";
import { Switchboard } from "../../../lib/events";
import { ClientLayer } from "../../../lib/layers";
import { ResultsMessage } from "../../messages/ResultsMessage";
export var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["FEET"] = "FEET";
    DistanceUnit["METERS"] = "METERS";
})(DistanceUnit || (DistanceUnit = {}));
export class BufferLayer extends ClientLayer {
    constructor(p_layer, config) {
        super();
        this.p_layer = p_layer;
        this.err_broadcaster = Switchboard.get_emitter("BUFFER_ERR");
        this.emitter = Switchboard.get_emitter("CONTEXT");
        this.options = {
            name: 'BufferLayer',
            fill_color: 'rgba(255,255,255,0.0)',
            stroke_color: 'rgba(199, 22, 199,1.0)',
            stroke_width: 3,
        };
        this.base = $('#buffer-dialog');
        this.distance_input = $("#buffer-request-distance");
        this.distance_input.on('change', () => this.onDistanceChange());
        this.unit_dropdown = $("#buffer-request-unit");
        this.unit_dropdown.on('change', () => this.onUnitChange());
        $('#buffer-request-cancel').on('click', () => this.hide());
        $('#buffer-request-initiate').on('click', () => this.bufferSearch());
        this.config = config;
        this.distance = 0;
        this.unit = DistanceUnit.FEET;
    }
    show() {
        this.base.toggleClass('hidden');
    }
    hide() {
        this.base.addClass('hidden');
        this.distance_input.val('');
        this.unit_dropdown.val('feet');
        this.distance_input.prop("disabled", false);
        $("#bsButton").removeClass('highlighted');
    }
    bufferSearch() {
        this.source.clear();
        if (this.unit_dropdown.val() === 'neighbor') {
            this.get_parcel_neighbours();
        }
        else {
            if (this.distance > 0) {
                this.get_parcel_buffer();
            }
        }
        this.base.addClass('hidden');
        $("#bsButton").removeClass('highlighted');
    }
    onUnitChange() {
        if (this.unit_dropdown.val() === "neighbor") {
            this.distance_input.prop("disabled", true);
            this.distance_input.val('');
            $('#buffer-request-initiate').text('Get Neighbors');
        }
        else {
            this.distance_input.prop("disabled", false);
            $('#buffer-request-initiate').text('Create Buffer');
            this.unit_dropdown.val() === 'feet' ? this.unit == DistanceUnit.FEET : this.unit = DistanceUnit.METERS;
        }
    }
    onDistanceChange() {
        this.distance = Number(this.distance_input.val());
    }
    async get_parcel_buffer() {
        const id = this.p_layer.clicked;
        let feature = await this.p_layer.get_feature_by_id(id);
        if (feature.isNone())
            return;
        let geometry;
        if (feature.unwrap().getGeometry() instanceof Point) {
            geometry = feature.unwrap().getGeometry();
        }
        else {
            geometry = feature.unwrap().getGeometry();
        }
        var options = { distance: this.distance, unit: this.unit };
        let bufferUrl = this.buildBufferUrl();
        if (bufferUrl === '')
            return;
        let response = await this.p_layer.data.get_buffer_by_geometry(geometry, bufferUrl, options);
        let buffer_err = response;
        if (buffer_err.error) {
            const err = `Buffer service error: ${buffer_err.error.message}. The server could not process buffer URL: ${bufferUrl}`;
            console.error(err);
            this.err_broadcaster.emit('buffer_err', '');
        }
        else {
            let b_feature = response;
            b_feature.setStyle(new Style({
                stroke: new Stroke({
                    color: this.options.stroke_color,
                    width: this.options.stroke_width,
                }),
            }));
            await this.source.addFeature(b_feature);
            let geom = b_feature.getGeometry();
            await this.p_layer.add_features_by_geometry(geom);
            this.emitter.emit('ctx_request', 'set');
            let list = this.p_layer.ids;
            new ResultsMessage({ command: 'RESULTS', list: list, name: '', type: '' }).send();
        }
    }
    async get_parcel_neighbours() {
        this.p_layer.remove_features_except(this.p_layer.clicked);
        const id = this.p_layer.clicked;
        let feature = await this.p_layer.get_feature_by_id(id);
        if (feature.isNone())
            return;
        let geometry;
        if (feature.unwrap().getGeometry() instanceof Point) {
            geometry = feature.unwrap().getGeometry();
        }
        else {
            geometry = feature.unwrap().getGeometry();
        }
        let features = await this.p_layer.data.get_neighbors_by_geometry(geometry, '');
        if (!features.isSome()) {
            alert("No neighbors found");
            return;
        }
        let rf = features.unwrap();
        let list = rf.map(f => f.get(this.p_layer.identifier));
        await this.p_layer.add_features_by_ids(list, id);
        this.emitter.emit('ctx_request', 'set');
        new ResultsMessage({ command: 'RESULTS', list: [...list, id], name: '', type: '' }).send();
    }
    buildBufferUrl() {
        if (this.config.BufferUrl) {
            try {
                return new URL(this.config.BufferUrl).href;
            }
            catch (error) {
                const err = `Could not parse "${this.config.BufferUrl}" as a URL.  Check "BufferUrl" property in the GIS configuration file. Error: ${error}.`;
                console.error(err);
                this.err_broadcaster.emit('buffer_err', '');
                return '';
            }
        }
        else {
            return this.deriveBufferUrl(this.config.ParcelQueryUrl);
        }
    }
    deriveBufferUrl(parcelQueryUrl) {
        try {
            let url = new URL(parcelQueryUrl);
            const bufferApiPath = 'rest/services/Utilities/Geometry/GeometryServer/buffer';
            let host = url.host;
            let protocol = url.protocol;
            let auxPathComponent = url.pathname.substring(0, url.pathname.indexOf('rest/services'));
            let bufferUrl = new URL(`${auxPathComponent}${bufferApiPath}`, `${protocol}//${host}`).href;
            return bufferUrl;
        }
        catch (ex) {
            const err = `Could not parse "${parcelQueryUrl}" as a URL.  Check the "ParcelQueryUrl" property in the GIS configuration file.`;
            console.error(err);
            this.err_broadcaster.emit('buffer_err', '');
            return '';
        }
    }
}
